import { useCallback, useState } from 'react';
import { onboardingService } from '@/features/onboarding/services/onboardingService';
import type { UserSelfOnboardPayload } from '@/features/onboarding/types/onboarding.types';
import { useSpinner, useToast } from '@chikara/ui';
import { t } from '@/i18n';


export const useUserSelfOnboard = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const toast = useToast();
    const [error, setError] = useState<string | null>(null);

    const selfOnboard = useCallback(async (payload: UserSelfOnboardPayload): Promise<boolean> => {
        show();
        setError(null);
        try {
            const response = await onboardingService.selfOnboard(payload);
            const ok = response?.response === 'OK';
            if (!ok) {
                const message = t('onboarding.personalInfo.errors.generic');
                setError(message);
                toast.error(message);
            }
            return ok;
        } catch (err) {
            // Endpoint is in SILENT_ERROR_ENDPOINTS — we own the user-facing message.
            const message = t('onboarding.personalInfo.errors.generic');
            setError(message);
            toast.error(message);
            return false;
        } finally {
            hide();
        }
    }, [show, hide, toast]);

    return {
        selfOnboard,
        isLoading: isSpinnerLoading,
        error,
        clearError: () => setError(null),
    };
};
